<template>
  <div class="layout-wrap">
    <GHeader />
    <div class="official">
      <div class="banner">
        <div class="main-banner">
          <img :src="game.background_url" />
        </div>
      </div>
      <nuxt />
    </div>
    <client-only>
      <LoginPop v-if="$store.state.app.showLoginPop" />
    </client-only>
    <XFooter />
  </div>
</template>

<script>
import LoginPop from '../components/logic-common/LoginPop'
import GHeader from '~/components/layout/GameHeader'
import XFooter from '~/components/logic-common/Footer'
export default {
  components: {
    GHeader,
    XFooter,
    LoginPop
  },
  computed: {
    game() {
      return this.$store.state.game.info
    }
  },
  created() {
    if (process.client) {
      const { game_id } = this.$route.params
      this.$store.dispatch('getUserInfo')
      this.$store.dispatch('game/getGameDetail', game_id)
      this.$store.dispatch('game/getServerList', game_id)
    }
  },
  head() {
    return {
      title: '迅雷游戏-' + this.game.title
    }
  }
}
</script>

<style lang="scss" src="~/assets/scss/official.scss"></style>
<style lang="scss" src="~/assets/scss/skin/skin_deep.scss"></style>
